/**
 * @file SubPromo.jsx
 * @description
 * SubPromo will only render:
 * - on homepage's Top Stories module or on topic pages, e.g. /health/,
 * - if a user is not logged in, and
 * - if there is an error rendering an ad and gpt.js appends the `is-empty` class to the ad
 */

import { useEntitlements } from "~features/access";

import subPromoLrgArtUrl from "~/assets/subPromoLrgArt.png";
import subPromoSmallArtUrl from "~/assets/subPromoSmallArt.gif";
import styles from "./SubPromo.module.css";

export default function SubPromo({ size = "small", option = "default" }) {
  const { hasDigitalAccess } = useEntitlements();

  // Do not render if user has a subscription or institutional access
  if (hasDigitalAccess) {
    return;
  }

  const isSmall = size === "small";
  const subPromoImg = isSmall ? subPromoSmallArtUrl : subPromoLrgArtUrl;

  const OPTIONS = {
    default: {
      mainText: "$1 for Digital Access",
      subText: "Read all the stories you want.",
      href: `/getsciam/60-day-offer/?utm_source=site&utm_medium=display&utm_campaign=evergreen-ads&utm_content=${isSmall ? "homepage_unit" : "collectionpage_unit"}&utm_term=60_day_1`,
    },
    variantOne: {
      mainText: "$0 for Digital Access",
      subText: "Read all the stories you want.",
      href: `/getsciam/free-trial-offer/?utm_source=site&utm_medium=display&utm_campaign=evergreen-ads&utm_content=${isSmall ? "homepage_unit" : "collectionpage_unit"}&utm_term=30_day_0`,
    },
    variantTwo: {
      mainText: "Get a subscription for $1",
      subText: "And start reading all of SciAm online",
      href: null,
    },
    variantThree: {
      mainText: "Goodbye Paywall. Hello Unlimited Reading.",
      subText: "Subscribe for $1.",
      href: null,
    },
  };

  return (
    <>
      <a
        href={OPTIONS[option].href}
        className={isSmall ? styles.subPromoContainer : styles.subPromoContainer__Large}
      >
        <img
          src={subPromoImg}
          alt=""
          className={isSmall ? styles.subPromoImg : styles.subPromoImg__Large}
        />
        <div
          className={isSmall ? styles.subPromoTextContainer : styles.subPromoTextContainer__Large}
        >
          <h2 className={isSmall ? styles.subPromoMainText : styles.subPromoMainText__Large}>
            {OPTIONS[option].mainText}
          </h2>
          <p className={styles.subPromoSubText}>{OPTIONS[option].subText}</p>
        </div>
        <span className={styles.subPromoCaret} />
      </a>
      {isSmall ? <hr className={styles.subPromoDivider} /> : null}
    </>
  );
}
